import { render, staticRenderFns } from "./preSell.vue?vue&type=template&id=a5b1a96c"
import script from "./preSell.vue?vue&type=script&lang=js"
export * from "./preSell.vue?vue&type=script&lang=js"
import style0 from "./preSell.vue?vue&type=style&index=0&id=a5b1a96c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports